/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1460
 */

module.exports = function (e, t) {
  if (("constructor" !== t || "function" !== typeof e[t]) && "__proto__" != t) {
    return e[t]
  }
}
